require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-roscoe-boxing-instructor-to-software-engineer-2.json") })
        }
      }, "path---blog-meet-roscoe-boxing-instructor-to-software-engineer-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-roscoe-boxing-instructor-to-software-engineer-2!./.cache/json/blog-meet-roscoe-boxing-instructor-to-software-engineer-2.json
// module id = 998
// module chunks = 231608221292675